<template>
  <Modal v-model="model" sticky reset-drag-position :title="title"  @on-cancel="cancel" footer-hide :mask="false" draggable scrollable class="message_template_pop" width="500">
    <div class="input_single">
      <div class="font_style_set" style="width:15%"><span style="color: #ed4014">*</span>{{inputName}}:</div>
      <Input type="textarea" v-model="blackReason" :rows="4"/>
    </div>
    
    <div class="btn_template" style="width: 100%;">
      <Button type="error"   class="cancel_btn" @click="cancel()">取消</Button>
      <Button type="primary" class="submit_btn" @click="transfer()">确定</Button>
    </div>
  </Modal>
</template>

<script>
  export default {
    name: "BlackSession",
    props: {
      showBlack:Boolean,
    },
    data(){
      return {
        model:false,
        agentNumber:'',
        selection:'',
        inputName:'原因',
        spinShowmail:true,
        tableClass: true,
        title:'加入黑名单',
        blackReason: '',
      }
    },
    methods:{
      cancel:function(){
        document.onkeydown = undefined;
        this.$emit("closeTransferPage",'cancel');
      },
      transfer:function () {
          if(!this.blackReason){
            this.$Message.error("请输入拉黑原因");
            return false;
          }
        this.$emit("closeTransferPage","3","",this.blackReason);
      },
      
    },
    watch:{
        showBlack: function(){
            this.model = this.showBlack;
        }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/OnlineService/BlackSession.vue